import type { LinkProps as NextLinkProps } from 'next/link';
export type Url = NextLinkProps['href'];

export default function stringifyUrl(href: Url) {
  return (
    (typeof href === 'string' || !href ? href : href.href || href.pathname)?.toLowerCase() || '/'
  );
}
